<template>
  <div class="form">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <button @click="validateForm()" class="btn fixed_btn">
        Save Visitor
      </button>
      <div class="card">
        <div class="inputs" v-if="visitor">
          <div class="input">
            <label>First Name<span class="required">*</span></label>
            <input v-model="visitor.first_name" />
          </div>
          <div class="input">
            <label>Last Name<span class="required">*</span></label>
            <input v-model="visitor.last_name" />
          </div>
          <div class="input">
            <label>Email Address</label>
            <input v-model="visitor.email" />
          </div>
          <div class="input">
            <label>Phone Number</label>
            <vue-tel-input v-model="visitor.phone"></vue-tel-input>
          </div>
          <div class="input">
            <label>Department</label>
            <v-select
              v-model="visitor.department"
              label="name"
              :reduce="(d) => d.id"
              :options="departments"
            >
            </v-select>
          </div>
          <div class="input">
            <label>Location<span class="required">*</span></label>
            <v-select
              v-model="visitor.location"
              label="name"
              :reduce="(d) => d.id"
              :options="locations"
            >
              <template v-slot:option="option">
                <div>
                  {{
                    `${option.name} - ${option.address_1}, ${option.city}, ${option.state}`
                  }}
                </div>
              </template>
            </v-select>
          </div>
          <div class="btns left">
            <button @click="validateForm()" class="btn round-btn">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import Swal from "sweetalert2";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
const functions = fb.default.functions;

export default {
  name: "visitor",
  data() {
    return {
      visitor: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        location: null,
        init_reminders: false,
        delivery_types: {
          email: false,
          text: false,
        },
      },
      locations: [],
      departments: [],
      new_visitor: false,
    };
  },
  firestore() {
    return {
      locations: db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("locations"),
      departments: db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("departments"),
    };
  },
  created() {
    this.$bind(
      "visitor",
      db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("visitor")
        .doc(this.$route.params.id)
    ).then((visitor) => {
      if (!visitor) {
        this.visitor = {
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          init_reminders: false,
          location: null,
          delivery_types: {
            email: false,
            text: false,
          },
        };
        this.new_visitor = true;
      }
    });
  },
  methods: {
    validateForm() {
      let valid = true;
      let visitor = this.visitor;

      for (let key in visitor) {
        if (
          (key == "phone" || key == "email") &&
          (key == "first_name" || key == "last_name" || key == "location")
        ) {
          if (!visitor[key]) valid = false;
        }
      }
      if (visitor["phone"] || visitor["email"]) {
        if (valid) {
          if (this.new_visitor) {
            this.checkForExisitingUser(visitor).then((res) => {
              let flag = Boolean(res[0]);
              if (!flag) {
                this.saveVisitor();
              } else {
                if (res[0]) {
                  return Swal.fire(
                    "Error: Can't assign same email",
                    "There's an existing visitor with the same email",
                    "warning"
                  );
                }
              }
            });
          } else {
            this.saveVisitor();
          }
        } else {
          return Swal.fire(
            "Warning",
            "Please fill in all required fields (*)",
            "warning"
          );
        }
      } else {
        return Swal.fire(
          "Warning",
          "Must add either an email or a phone number",
          "warning"
        );
      }
    },
    saveVisitor() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });

      return Promise.resolve()
        .then(() => {
          if (this.visitor.id) {
            return this.$firestoreRefs.visitor.set(this.visitor, {
              merge: true,
            });
          } else {
            const checkLimitAndCreate = functions.httpsCallable(
              "checkLimitAndCreate"
            );
            return checkLimitAndCreate({
              path: this.$firestoreRefs.visitor.path,
              field: "users",
              payload: this.visitor,
            });
          }
        })
        .then(() => {
          loader.hide();
          return Swal.fire("Visitor Saved");
        })
        .then(() => {
          return this.goTo("/visitors");
        })
        .catch((err) => {
          loader.hide();
          Swal.fire("Error", err.message, "error");
        });
    },
    async checkForExisitingUser(visitor) {
      let email = await db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("visitor")
        .where("email", "==", visitor.email)
        .get()
        .then((query) => query.size);

      return Promise.all([email]);
    },
  },
};
</script>

<style scoped lang="scss">
.totals {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 20px 0;
  p {
    margin-left: 40px;
    font-size: 15px;
    span {
      font-size: 35px;
      font-weight: bold;
      font-family: "SFProDisplay", sans-serif;
      display: block;
    }
  }
}
h3 {
  margin-top: 30px;
}

.text_btn {
  text-decoration: underline;
}

.input-btn {
  display: flex;
  align-items: center;
  input {
    width: 100%;
  }
  .btn {
    flex: none;
    padding-top: 0;
  }
}

.add-answer {
  padding-top: 20px;
  margin-top: 20px;
  border-top: 2px solid #eaeaea;
}

.answers {
  input {
    margin-bottom: 6px !important;
    padding: 5px 15px !important;
    font-size: 15px !important;
  }
}

.add-question {
  margin-top: 30px;
}

h4 {
  margin-top: 0;
  font-weight: 500;
  span {
    display: block;
    font-size: 25px;
    margin-top: 5px;
    font-weight: bold;
  }
}

.question {
  padding: 15px 30px !important;
  position: relative;
  ul {
    margin-bottom: 0;
  }
  .controls {
    display: flex;
    position: absolute;
    right: 20px;
    top: 20px;
    align-items: center;
    img {
      height: 30px;
      margin-left: 20px;
      cursor: pointer;
    }
  }
}
</style>
